import { passwordRules } from '../utils'

export interface PasswordValidationResult {
  valid: boolean
  errors: string[]
}

export function validatePassword(password: string): PasswordValidationResult {
  const errors: string[] = []
  for (const rule of passwordRules) {
    const result = rule(password)
    if (result !== true) errors.push(result as string)
  }
  return { valid: errors.length === 0, errors }
}

export function isCompliantPassword(password: string): boolean {
  return validatePassword(password).valid
}
